import { noop, useIntl } from '@capsicum/common';
import { useInfoModal } from '@capsicum/common-web';

type UpdateAppModalProps = {
	isForcedRequirement?: boolean;
	onDismiss?: () => void;
};

export const useUpdateAppModal = ({ isForcedRequirement, onDismiss }: UpdateAppModalProps) => {
	const { $t } = useIntl();
	const { showInfoModal } = useInfoModal();

	const showUpdateAppModal = () => {
		if (isForcedRequirement) {
			showInfoModal({
				image: 'upgrade',
				isClosable: !onDismiss,
				onDismiss,
				subtitle: $t('jurisdictionRequirements.unsupportedType.message'),
				testID: 'warning',
				title: $t('jurisdictionRequirements.unsupportedType.title'),
				variant: 'no-button'
			});
		} else {
			showInfoModal({
				buttonOnHandlers: {
					onPrimaryButtonHandler: noop
				},
				buttonTexts: {
					primaryButtonText: $t('button.gotIt')
				},
				image: 'upgrade',
				isClosable: !onDismiss,
				onDismiss,
				subtitle: $t('jurisdictionRequirements.unsupportedType.message'),
				testID: 'warning',
				title: $t('jurisdictionRequirements.unsupportedType.title'),
				variant: 'alert'
			});
		}
	};

	return {
		showUpdateAppModal
	};
};
